import {
  GET_VENDOR_RETAIL_BOOKINGS,
  GET_VENDOR_RETAIL_BOOKINGS_SUCCESS,
  GET_VENDOR_RETAIL_BOOKINGS_FAILED,
  GET_VENDOR_UNPAID_RETAIL_BOOKINGS,
  GET_VENDOR_UNPAID_RETAIL_BOOKINGS_SUCCESS,
  GET_VENDOR_UNPAID_RETAIL_BOOKINGS_FAILED,
  GET_VENDOR_PAID_RETAIL_BOOKINGS,
  GET_VENDOR_PAID_RETAIL_BOOKINGS_SUCCESS,
  GET_VENDOR_PAID_RETAIL_BOOKINGS_FAILED,
  FIND_VENDOR_RETAIL_BOOKING,
  VENDOR_RETAIL_NOT_BOOKED,
  CREATE_VENDOR_RETAIL_BOOKING,
  CREATE_VENDOR_RETAIL_BOOKING_SUCCESS,
  CREATE_VENDOR_RETAIL_BOOKING_FAILED,
  SET_VENDOR_RETAIL_PAYLOAD,
  SET_TOTAL_BOOKING_AMOUNT,
  CHECK_SLOT_AVAILABILITY,
  CHECK_SLOT_AVAILABILITY_SUCCESS,
  CHECK_SLOT_AVAILABILITY_FAILED,
  CREATE_RETAIL_CHECKOUT_SESSION,
  CREATE_RETAIL_CHECKOUT_SESSION_SUCCESS,
  CREATE_RETAIL_CHECKOUT_SESSION_FAILED,
  CANCEL_RETAIL_BOOKING,
  CANCEL_RETAIL_BOOKING_SUCCESS,
  CANCEL_RETAIL_BOOKING_FAILED,
  RESET_VENDOR_RETAIL,
  GET_VENUE_RETAIL_APPLICATIONS,
  GET_VENUE_RETAIL_APPLICATIONS_SUCCESS,
  GET_VENUE_RETAIL_APPLICATIONS_FAILED,
  UPDATE_RETAIL_APPLICATION_STATUS,
  UPDATE_RETAIL_APPLICATION_STATUS_SUCCESS,
  UPDATE_RETAIL_APPLICATION_STATUS_FAILED,
  VENUE_CANCEL_RETAIL_BOOKING,
  VENUE_CANCEL_RETAIL_BOOKING_SUCCESS,
  VENUE_CANCEL_RETAIL_BOOKING_FAILED,
} from './constants';

export const resetVendorRetailState = () => ({ type: RESET_VENDOR_RETAIL });

export const getVendorRetailBookings = (vendorId) => ({
  type: GET_VENDOR_RETAIL_BOOKINGS,
  payload: { vendorId },
});

export const getVendorRetailBookingsSuccess = (bookings) => ({
  type: GET_VENDOR_RETAIL_BOOKINGS_SUCCESS,
  payload: { bookings },
});

export const getVendorRetailBookingsFailed = (error) => ({
  type: GET_VENDOR_RETAIL_BOOKINGS_FAILED,
  payload: { error },
});

// Unpaid bookings (for payments page)
export const getVendorUnpaidRetailBookings = (vendorId) => ({
  type: GET_VENDOR_UNPAID_RETAIL_BOOKINGS,
  payload: { vendorId },
});

export const getVendorUnpaidRetailBookingsSuccess = (bookings) => ({
  type: GET_VENDOR_UNPAID_RETAIL_BOOKINGS_SUCCESS,
  payload: { bookings },
});

export const getVendorUnpaidRetailBookingsFailed = (error) => ({
  type: GET_VENDOR_UNPAID_RETAIL_BOOKINGS_FAILED,
  payload: { error },
});

// Paid bookings (for payments page - Paid tab)
export const getVendorPaidRetailBookings = (vendorId) => ({
  type: GET_VENDOR_PAID_RETAIL_BOOKINGS,
  payload: { vendorId },
});

export const getVendorPaidRetailBookingsSuccess = (bookings) => ({
  type: GET_VENDOR_PAID_RETAIL_BOOKINGS_SUCCESS,
  payload: { bookings },
});

export const getVendorPaidRetailBookingsFailed = (error) => ({
  type: GET_VENDOR_PAID_RETAIL_BOOKINGS_FAILED,
  payload: { error },
});

export const findVendorRetailBooking = (vendorId, retailScheduleId, bookingDate) => ({
  type: FIND_VENDOR_RETAIL_BOOKING,
  payload: { vendorId, retailScheduleId, bookingDate },
});

export const vendorRetailNotBooked = () => ({ type: VENDOR_RETAIL_NOT_BOOKED });

export const createVendorRetailBooking = (bookingData) => ({
  type: CREATE_VENDOR_RETAIL_BOOKING,
  payload: bookingData,
});

export const createVendorRetailBookingSuccess = (booking) => ({
  type: CREATE_VENDOR_RETAIL_BOOKING_SUCCESS,
  payload: { booking },
});

export const createVendorRetailBookingFailed = (error) => ({
  type: CREATE_VENDOR_RETAIL_BOOKING_FAILED,
  payload: { error },
});

export const setVendorRetailPayload = (payload) => ({
  type: SET_VENDOR_RETAIL_PAYLOAD,
  payload,
});

export const setTotalBookingAmount = (amount) => ({
  type: SET_TOTAL_BOOKING_AMOUNT,
  payload: { amount },
});

export const checkSlotAvailability = (retailScheduleId, bookingDate, startTime, endTime) => ({
  type: CHECK_SLOT_AVAILABILITY,
  payload: { retailScheduleId, bookingDate, startTime, endTime },
});

export const checkSlotAvailabilitySuccess = (available) => ({
  type: CHECK_SLOT_AVAILABILITY_SUCCESS,
  payload: { available },
});

export const checkSlotAvailabilityFailed = (error) => ({
  type: CHECK_SLOT_AVAILABILITY_FAILED,
  payload: { error },
});

export const createRetailCheckoutSession = (sessionData) => ({
  type: CREATE_RETAIL_CHECKOUT_SESSION,
  payload: sessionData,
});

export const createRetailCheckoutSessionSuccess = (session) => ({
  type: CREATE_RETAIL_CHECKOUT_SESSION_SUCCESS,
  payload: { session },
});

export const createRetailCheckoutSessionFailed = (error) => ({
  type: CREATE_RETAIL_CHECKOUT_SESSION_FAILED,
  payload: { error },
});

export const cancelRetailBooking = (bookingId, vendorId, reason) => ({
  type: CANCEL_RETAIL_BOOKING,
  payload: { bookingId, vendorId, reason },
});

export const cancelRetailBookingSuccess = (booking) => ({
  type: CANCEL_RETAIL_BOOKING_SUCCESS,
  payload: { booking },
});

export const cancelRetailBookingFailed = (error) => ({
  type: CANCEL_RETAIL_BOOKING_FAILED,
  payload: { error },
});

// Venue-side: Get applications
export const getVenueRetailApplications = (venueId) => ({
  type: GET_VENUE_RETAIL_APPLICATIONS,
  payload: { venueId },
});

export const getVenueRetailApplicationsSuccess = (applications) => ({
  type: GET_VENUE_RETAIL_APPLICATIONS_SUCCESS,
  payload: { applications },
});

export const getVenueRetailApplicationsFailed = (error) => ({
  type: GET_VENUE_RETAIL_APPLICATIONS_FAILED,
  payload: { error },
});

// Venue-side: Update application status
export const updateRetailApplicationStatus = (bookingId, newStatus, onStatusChanged) => ({
  type: UPDATE_RETAIL_APPLICATION_STATUS,
  payload: { bookingId, newStatus, onStatusChanged },
});

export const updateRetailApplicationStatusSuccess = (booking) => ({
  type: UPDATE_RETAIL_APPLICATION_STATUS_SUCCESS,
  payload: { booking },
});

export const updateRetailApplicationStatusFailed = (error) => ({
  type: UPDATE_RETAIL_APPLICATION_STATUS_FAILED,
  payload: { error },
});

// Venue-side: Cancel retail booking
export const venueCancelRetailBooking = (bookingId, venueId, reason, onCancelled) => ({
  type: VENUE_CANCEL_RETAIL_BOOKING,
  payload: { bookingId, venueId, reason, onCancelled },
});

export const venueCancelRetailBookingSuccess = (booking) => ({
  type: VENUE_CANCEL_RETAIL_BOOKING_SUCCESS,
  payload: { booking },
});

export const venueCancelRetailBookingFailed = (error) => ({
  type: VENUE_CANCEL_RETAIL_BOOKING_FAILED,
  payload: { error },
});
